<template>
  <div class="login-container">
    <div class="title"></div>
    <div class="login-box">
      <div class="huanying">欢迎登陆</div>
      <el-form ref="loginFormRef" :rules="loginFormRules" :model="loginForm">
        <el-form-item prop="username">
          <i class="icon_user" style="height:1.05vw;line-height:2vw">
            <img src="../../assets/img/login/user.png" alt />
          </i>
          <input class="input_inner username" v-model="loginForm.username" @keyup.13="login" placeholder="请输入账号" />
          <i class="icon_duigou">
            <img :src="this.src.icon" alt />
          </i>
        </el-form-item>
        <el-form-item prop="password">
          <i class="icon_user">
            <img src="../../assets/img/login/pass.png" alt />
          </i>
          <input type="password" v-model="loginForm.password" @keyup.13="login" placeholder="请输入密码" class="input_inner password" />
          <i class="icon_duigou">
            <img :src="this.src.icons" alt />
          </i>
        </el-form-item>
        <!--<el-form-item prop="md5password">
              <el-input type="hidden" id="md5password"></el-input>
        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" style="width:100%;" @click="login()" :disabled=" isLoading " :loading=" isLoading ">立即登录</el-button>
        </el-form-item>
      </el-form>
      <div class="zhuce">
        <span>还没有账号？</span>
        <router-link to="register">立即注册</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      capObj: null, // 用于接收极验窗口对象的
      isLoading: false, // 设置按钮是否处于等待效果(和是否禁用)
      src: {
        icon: require('@/assets/img/login//duigou.png'),
        icons: require('@/assets/img/login//duigou.png'),
        text: '图片',
        type: 'ui-picture',
      },
      loginForm: {
        username: '',
        password: '',
      },
      loginFormRules: {
        username: [
          { required: true, message: '账号必填' },
          // { pattern: /^1[35789]\d{9}$/, message: '账号格式不对' }
        ],
        password: [{ required: true, message: '密码必填' }],
      },
      // options: regionDataPlus,
      selectedOptions: [],
    };
  },
  // created () {
  //   this.login()
  // },
  watch: {
    'loginForm.username'(newVal, oldVal) {
      this.src.icon = require('@/assets/img/login//duigou_green.png');
      // console.log(newVal, oldVal)
      if (newVal === '') {
        this.src.icon = require('@/assets/img/login//duigou_red.png');
      }
    },
    'loginForm.password'(newVal, oldVal) {
      this.src.icons = require('@/assets/img/login//duigou_green.png');
      // console.log(newVal, oldVal)
      if (newVal === '') {
        this.src.icons = require('@/assets/img/login//duigou_red.png');
      }
    },
  },
  methods: {
    login() {
      // this.$router.push({ name: 'home' }) // name属性实现编程式导航
      // console.log('loginForm ====================' + this.loginForm.username + 'area: ' + this.selectedOptions)

      // this.$router.push({ name: 'home' })

      this.loginForm.md5password = this.$md5(this.loginForm.password);

      this.$refs.loginFormRef.validate((valid) => {
        // valid:true 校验通过
        // valid:false 校验失败
        // 校验失败，代码停止
        // console.log(this.loginFormRules.username[0].required)
        // if (this.loginFormRules.username[0].required && this.loginFormRules.password[0].required) {
        //   this.src.icon = require('@/assets/img/login//duigou_red.png')
        //   this.src.icons = require('@/assets/img/login//duigou_red.png')
        // }
        // console.log(valid)

        // if (!valid) { return false }
        // // console.log(valid + '---------')
        // // 判断极验窗口对象存在，就直接使用
        // if (this.capObj !== null) {
        //   return this.capObj.verify() // 激活窗口显示
        // }

        // 设置登录按钮等待、禁用状态
        // this.isLoading = true
        // this.$router.push('/home') // 路由地址 实现导航

        // var data = Qs.stringify({ username: this.loginForm.username, password: this.loginForm.md5password })
        // 路由编程式导航
        let pro = this.$http({
          url: '/auth/login',
          method: 'POST',
          // data: data
          data: { username: this.loginForm.username, password: this.loginForm.md5password },
        });
        pro
          .then((result) => {
            if (result.data.code === 0) {
              window.sessionStorage.setItem('userinfo', JSON.stringify(result.data.data.token));
              window.sessionStorage.setItem('username', result.data.data.username);
              window.sessionStorage.setItem('orgid', result.data.data.orgid);
              window.sessionStorage.setItem('orgName', result.data.data.orgName);
              window.sessionStorage.setItem('logoUrl', result.data.data.logoUrl);
              window.sessionStorage.setItem('orgNum', result.data.data.orgNum);
              window.sessionStorage.setItem('roleName', result.data.data.roleName);
              window.sessionStorage.setItem('headmaster', result.data.data.headmaster);
              window.sessionStorage.setItem('tipsNum', 0);
              if (result.data.data.headmaster === '1') {
                this.$router.push({ name: 'campusmanagement' });
              } else {
                this.$router.push({ name: 'home' });
              }
            } else {
              this.$message.error(result.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error('系统错误：' + err);
          });
      });
    },
  },
};
</script>

<style lang="less">
.login-container {
  font-family: '微软雅黑';
  background: url(../../assets/img/login/bg.png) no-repeat;
  width: 100%;
  height: 100%;
  background-size: cover;
  .title {
    height: 32%;
  }
  .login-box {
    background: rgba(255, 255, 255, 1);
    box-shadow: 2px 4px 20px rgba(68, 68, 68, 0.16);
    border-radius: 10px;
    width: 20%;
    position: fixed;
    right: 15%;
    .huanying {
      font-size: 1.4vw;
      letter-spacing: 5px;
      color: #0094ce;
      display: flex;
      justify-content: center;
      padding: 13% 0 10% 0;
      font-weight: 550;
    }
    .el-form {
      width: 90%;
      margin: 0 auto;
      overflow: hidden;
      .el-form-item {
        margin-bottom: 16px;
      }
      .icon_user {
        width: 1vw;
        height: 1.2vw;
        position: absolute;
        top: 20%;
        left: 5%;
        line-height: 2.2vw;
        img {
          width: 100%;
          height: 100%;
          opacity: 0.8;
        }
      }
      .input_inner {
        font-size: 0.8vw;
        line-height: 3.1;
        background: #f7f7f7;
        color: #333;
        border: 0px;
        width: 68%;
        padding: 0 16%;
        border-radius: 3px;
      }
      .icon_duigou {
        width: 0.9vw;
        height: 0.9vw;
        position: absolute;
        top: 20%;
        right: 5%;
        line-height: 2vw;
        img {
          width: 100%;
          height: 100%;
        }
      }
      input:focus {
        outline: 0;
      }
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #dadada;
      }
      .el-button {
        font-size: 0.9vw;
        letter-spacing: 2px;
        font-weight: 549;
        margin-top: 4%;
        background: rgba(0, 148, 206, 1);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        height: 2.6vw;
        border-radius: 50px;
      }
    }
    .zhuce {
      font-size: 0.8vw;
      color: #ccc;
      margin: 0px 0 6% 6%;
      a {
        text-decoration: none;
        color: #0094ce;
        font-weight: 549;
      }
    }
  }
}
</style>
